import { NormalizedRealtimePayload } from './api.types';
import {
  AssignmentsViewOptions,
  AssignmentsWorkTypeMap,
  MSAssignmentsStatusOptions,
} from './assignment.types';
import { Class } from './class.types';
import { GRADES } from './grades.types';

export interface AssignmentsViewState {
  activeAssignmentsView: AssignmentsViewOptions;
  isNoAssignmentsDataViewMS: boolean | null;
  isNoAssignmentsDataToDo: boolean | null;
  isNoAssignmentsDataPastWork: boolean | null;
  // TODO: Remove the 'isUpdatedMSViewEnabled' feature flag related items after RFS.
  activeMSAssignmentsStatus: MSAssignmentsStatusOptions | null;
  // This is for API queries, so it should only be TODO or PAST_WORK (never APPS)
  activeMSAssignmentsWorkType: AssignmentsWorkTypeMap;
  activeMSAssignmentsSubject: string | null;
}

// @TODO add typings for AvatarState properties if possible
export interface AvatarState {
  bigAvatarConfig: unknown;
  smallAvatarConfig: unknown;
  teacherAvatarConfig: unknown;
  msStudentAvatarConfig: unknown;
}

export interface GradeState {
  currentGrade: GRADES;
  isGradeDefined: boolean;
}

export type ScheduledAssignmentEventsState = NormalizedRealtimePayload[];

export interface UserClassesState {
  selectedClass: Class[] | null | undefined;
  activeUserClasses: Class[] | undefined;
}

export enum CurrentAppViewOptions {
  ELEMENTARY_SCHOOL = 'ELEMENTARY_SCHOOL',
  MIDDLE_SCHOOL = 'MIDDLE_SCHOOL',
}

export interface CurrentAppViewState {
  currentAppView: CurrentAppViewOptions | null;
  isViewDefined: boolean;
  hasViewUpdated: boolean;
}

export interface SingleSessionCodeState {
  isSingleSessionCodeModalOpen: boolean;
}

export interface MSProductsEntitlementsState {
  hasMiddleSchoolProduct: boolean | null;
}

export interface AssignmentsXApiPayload {
  assignmentsTotalCount: number;
  displayedAssignmentsCount: number;
  doneAssignmentsCount: number;
}
